import { FC } from "react";
import { Modal } from "@monolith-forensics/monolith-ui";
import { EditStorageForm } from "../Forms/EditStorageForm";
import { StorageItemForEdit } from "../storage.types";

interface EditStorageModalProps {
  open: boolean;
  handleClose: () => void;
  onEditSubmit: (updateData: Partial<StorageItemForEdit>) => void;
  defaultStorageInfo: StorageItemForEdit | null;
}

export const EditStorageModal: FC<EditStorageModalProps> = ({
  open,
  handleClose,
  onEditSubmit,
  defaultStorageInfo,
}) => {
  const handleSubmit = (updateData: Partial<StorageItemForEdit>) => {
    onEditSubmit?.(updateData);
    handleClose();
  };

  const handleCancel = () => handleClose();

  if (!defaultStorageInfo) return null;

  return (
    <Modal open={open} onClose={handleClose}>
      <EditStorageForm
        onSubmit={handleSubmit}
        onCancel={handleCancel}
        defaultStorageInfo={defaultStorageInfo}
        width={700}
      />
    </Modal>
  );
};
